export const DEFAULT_ZAI_TAG_BUTTON_ICON_COLOR = 'var(--color_neutral_0)'

export const ICON_SIZE = { width: 24, height: 24 }
